"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_uniqby_1 = __importDefault(require("lodash.uniqby"));
var BaseTypeAdaptor_1 = __importDefault(require("./BaseTypeAdaptor"));
var ArrayTypeAdaptor = /** @class */ (function (_super) {
    __extends(ArrayTypeAdaptor, _super);
    function ArrayTypeAdaptor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.$type = "array";
        return _this;
    }
    ArrayTypeAdaptor.prototype.getSize = function (array) {
        return array.length;
    };
    ArrayTypeAdaptor.prototype.setItemAdaptor = function (adaptor) {
        this.$itemAdaptor = adaptor;
        adaptor.setArrayAdaptor(this);
        this.getSchemaType().of(adaptor.getSchemaType());
    };
    ArrayTypeAdaptor.prototype.getItemAdaptor = function () {
        return this.$itemAdaptor;
    };
    // ArrayType() native methods
    ArrayTypeAdaptor.prototype.between = function (min, max) {
        this.getSchemaType().rangeLength(min, max, this.getErrorMessage("between", { min: min, max: max }));
        return this;
    };
    ArrayTypeAdaptor.prototype.min = function (value) {
        this.getSchemaType().minLength(value, this.getErrorMessage("min", { value: value }));
        return this;
    };
    ArrayTypeAdaptor.prototype.max = function (value) {
        this.getSchemaType().maxLength(value, this.getErrorMessage("max", { value: value }));
        return this;
    };
    ArrayTypeAdaptor.prototype.unique = function (by) {
        if (!by) {
            this.getSchemaType().unrepeatable(this.getErrorMessage("unique"));
        }
        else {
            this.getSchemaType().addRule(function (array) {
                return array.length === (0, lodash_uniqby_1.default)(array, by).length;
            }, this.getErrorMessage("unique", { by: by }));
        }
        return this;
    };
    return ArrayTypeAdaptor;
}(BaseTypeAdaptor_1.default));
exports.default = ArrayTypeAdaptor;
